import React, { useContext } from 'react'
import PrimaryButton from '../../../../global/components/buttons/primary-button/PrimaryButton'
import styles from './styles.module.css'
import HolidayModal from '../../holiday-modal/container/HolidayModal'
import { UserContext } from '../../../../base/components/base-container/BaseContainer'
import { ROLES } from '../../../../global/constants/users'

export default function NewHoliday(props: any) {
  const { user } = useContext(UserContext)
  const { refreshCounter, setRefreshCounter } = props.refresh
  const [open, setOpen] = React.useState(false)

  const canSeeCreateButton = [ROLES.ADMIN, ROLES.SUPER_ADMIN].includes(
    user?.role || '',
  )

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClosed = () => {
    setOpen(false)
  }

  return canSeeCreateButton ? (
    <div>
      <PrimaryButton buttonName='Create' onClick={handleOpen} />
      {open && (
        <HolidayModal
          isOpen={open}
          handleClosed={handleClosed}
          refresh={setRefreshCounter}
        />
      )}
    </div>
  ) : (
    <></>
  )
}
